export const IsDocumentDefined = () => typeof document !== `undefined`;
